import { render, staticRenderFns } from "./LibraryBookPermission.vue?vue&type=template&id=0e58b8e0&"
import script from "./LibraryBookPermission.vue?vue&type=script&lang=js&"
export * from "./LibraryBookPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports